import { computed } from "vue";
function integrationEnabled() {
    // @ts-ignore
    return window.marque.ui.accountingIntegrationProvider === 'xero';
}
function latestXeroReference(collection) {
    return computed(() => {
        const sorted = collection?.sort((a, b) => {
            if (a.batch_id > b.batch_id)
                return 1;
            if (a.batch_id === b.batch_id)
                return 0;
            return -1;
        });
        if (sorted) {
            return sorted[sorted.length - 1];
        }
        return;
    });
}
function latestXeroReferenceIsError(reference) {
    return computed(() => {
        return reference.value?.error_type === 'error';
    });
}
function xeroErrorMessages(reference) {
    return computed(() => {
        const json = reference.value?.description;
        if (json) {
            return JSON.parse(json);
        }
        return [];
    });
}
function xeroErrorMessage(reference) {
    return computed(() => {
        const json = reference.value?.description;
        if (json) {
            const messages = JSON.parse(json);
            console.log(messages);
            return messages.join(', ');
        }
        return '';
    });
}
export { integrationEnabled, latestXeroReference, latestXeroReferenceIsError, xeroErrorMessage, xeroErrorMessages };
